import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { DocumentWrapper } from '../../../components/DocumentWrapper/DocumentWrapper'
import document from './TermsOfUseForAiAssistants.md'

export const AssistantsUsageAgreementPage: FC = () => {
    const navigate = useNavigate()

    const handleBack = () => {
        navigate(-1)
    }

    const handleDownloadDocument = () => {
        window.open('/terms-of-use-for-ai-assistants.pdf')
    }

    return (
        <DocumentWrapper
            title="Условие использования AI-ассистентов"
            onBack={handleBack}
            onDownload={handleDownloadDocument}
            document={document}
        />
    )
}
